import { Pipe, PipeTransform } from '@angular/core';
import { NiceConstService } from '@shared/services';

@Pipe({
    name: 'niceConst'
})
export class NiceConstPipe extends NiceConstService implements PipeTransform {
}
